module.exports = __webpack_public_path__ + "img/BP1.876de716.png";